import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { libroreclamacionesAdd, messageClear } from "../store/reducers/libroreclamacionesReducer";
import toast from "react-hot-toast";
import { FadeLoader } from "react-spinners";

const LibrodeReclamaciones = () => {
  const navigate = useNavigate();
  const { loader, errorMessage, successMessage } = useSelector(state => state.libroreclamaciones);
  const dispatch = useDispatch();

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  }, [successMessage, errorMessage, dispatch, navigate]);

  const [state, setState] = useState({
    tipoDocumento: "DNI",
    numeroDocumento: "",
    nombres: "",
    apellidos: "",
    email: "",
    telefono: "",
    direccion: "",
    departamento: "",
    provincia: "",
    distrito: "",
    detalleReclamo: "",
    pedidoRelacionado: "",
    tipoReclamo: "queja",
    archivo: null,
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = e => {
    const { name, value, files } = e.target;
    setState({
      ...state,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    console.log("Formulario enviado:", state);

    const formData = new FormData();
    formData.append("tipoDocumento", state.tipoDocumento);
    formData.append("numeroDocumento", state.numeroDocumento);
    formData.append("nombres", state.nombres);
    formData.append("apellidos", state.apellidos);
    formData.append("email", state.email);
    formData.append("telefono", state.telefono);
    formData.append("direccion", state.direccion);

    formData.append("departamento", state.departamento);
    formData.append("provincia", state.provincia);
    formData.append("distrito", state.distrito);
    formData.append("detalleReclamo", state.detalleReclamo);
    formData.append("pedidoRelacionado", state.pedidoRelacionado);
    formData.append("tipoReclamo", state.tipoReclamo);

    // for (let i = 0; i < files.length; i++) {
    formData.append("archivo", state.archivo);
    //  }
    dispatch(libroreclamacionesAdd(formData));

    // Aquí iría la lógica para enviar los datos al backend
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div>
        {loader && (
          <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
            <FadeLoader />
          </div>
        )}
        <Header />
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-6 text-center">
          <p className="font-bold">¡Reclamo registrado exitosamente!</p>
          <p>Hemos recibido tu reclamo y nos comunicaremos contigo en un plazo máximo de 15 días hábiles.</p>
          <button onClick={() => setSubmitted(false)} className="mt-4 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded">
            Realizar nuevo reclamo
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      <Header />
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
          {/* Encabezado */}
          <div className="bg-white py-4 px-6">
            <h1 className="text-2xl font-bold text-gray-800 pb-2 text-center">Libro de Reclamaciones (Ley N° 29571)</h1>
            <ul class="space-y-4 pl-5 text-gray-800 list-none text-center">
              <li class="pb-2">
                <p>INVERSIONES KLMA E.I.R.L - RUC: 20602845941</p> <p>CAL. HURTADO GARCIA DE MENDOZA MZA. B2 LOTE. 58 URB. LAS CASCADAS DE SAN ANTON LIMA - LIMA - CARABAYLLO</p>{" "}
              </li>
            </ul>

            <p className="text-gray-800 mt-1">
              Gracias por comunicarte con nosotros. Estaremos dando respuesta a tu queja o reclamo en un plazo no mayor a (15) días hábiles improrrogables, de acuerdo con la Ley Nº31435 del Código de
              protección y Defensa del Consumidor.
            </p>
          </div>

          {/* Formulario */}
          <form onSubmit={handleSubmit} className="p-6 space-y-6">
            {/* Sección Datos Personales */}
            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-lg font-medium text-gray-900 mb-4">Datos Personales</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Tipo de Documento */}
                <div>
                  <label htmlFor="tipoDocumento" className="block text-sm font-medium text-gray-700">
                    Tipo de Documento *
                  </label>
                  <select
                    id="tipoDocumento"
                    name="tipoDocumento"
                    value={state.tipoDocumento}
                    onChange={handleChange}
                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-pink-custom focus:border-pink-custom sm:text-sm rounded-md border"
                    required>
                    <option value="DNI">DNI</option>
                    <option value="CE">Carnet de Extranjería</option>
                    <option value="PASAPORTE">Pasaporte</option>
                    <option value="RUC">RUC</option>
                  </select>
                </div>

                {/* Número de Documento */}
                <div>
                  <label htmlFor="numeroDocumento" className="block text-sm font-medium text-gray-700">
                    Número de Documento *
                  </label>
                  <input
                    type="text"
                    id="numeroDocumento"
                    name="numeroDocumento"
                    value={state.numeroDocumento}
                    onChange={handleChange}
                    className="mt-1 focus:ring-pink-custom focus:border-pink-custom block w-full shadow-sm sm:text-sm border-gray-300 rounded-md border p-2"
                    required
                  />
                </div>

                {/* Nombres */}
                <div>
                  <label htmlFor="nombres" className="block text-sm font-medium text-gray-700">
                    Nombres *
                  </label>
                  <input
                    type="text"
                    id="nombres"
                    name="nombres"
                    value={state.nombres}
                    onChange={handleChange}
                    className="mt-1 focus:ring-pink-custom focus:border-pink-custom block w-full shadow-sm sm:text-sm border-gray-300 rounded-md border p-2"
                    required
                  />
                </div>

                {/* Apellidos */}
                <div>
                  <label htmlFor="apellidos" className="block text-sm font-medium text-gray-700">
                    Apellidos *
                  </label>
                  <input
                    type="text"
                    id="apellidos"
                    name="apellidos"
                    value={state.apellidos}
                    onChange={handleChange}
                    className="mt-1 focus:ring-pink-custom focus:border-pink-custom block w-full shadow-sm sm:text-sm border-gray-300 rounded-md border p-2"
                    required
                  />
                </div>

                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Correo Electrónico *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={state.email}
                    onChange={handleChange}
                    className="mt-1 focus:ring-pink-custom focus:border-pink-custom block w-full shadow-sm sm:text-sm border-gray-300 rounded-md border p-2"
                    required
                  />
                </div>

                {/* Teléfono */}
                <div>
                  <label htmlFor="telefono" className="block text-sm font-medium text-gray-700">
                    Teléfono / Celular *
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={state.telefono}
                    onChange={handleChange}
                    className="mt-1 focus:ring-pink-custom focus:border-pink-custom block w-full shadow-sm sm:text-sm border-gray-300 rounded-md border p-2"
                    required
                  />
                </div>
              </div>
            </div>

            {/* Sección Dirección */}
            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-lg font-medium text-gray-900 mb-4">Dirección</h2>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Departamento */}
                <div>
                  <label htmlFor="departamento" className="block text-sm font-medium text-gray-700">
                    Departamento *
                  </label>
                  <select
                    id="departamento"
                    name="departamento"
                    value={state.departamento}
                    onChange={handleChange}
                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-pink-custom focus:border-pink-custom sm:text-sm rounded-md border"
                    required>
                    <option value="">Seleccionar</option>
                    <option value="Lima">Lima</option>
                    <option value="Arequipa">Arequipa</option>
                    <option value="Cusco">Cusco</option>
                    {/* Agregar más departamentos según sea necesario */}
                  </select>
                </div>

                {/* Provincia */}
                <div>
                  <label htmlFor="provincia" className="block text-sm font-medium text-gray-700">
                    Provincia *
                  </label>
                  <input
                    type="text"
                    id="provincia"
                    name="provincia"
                    value={state.provincia}
                    onChange={handleChange}
                    className="mt-1 focus:ring-pink-custom focus:border-pink-custom block w-full shadow-sm sm:text-sm border-gray-300 rounded-md border p-2"
                    required
                  />
                </div>

                {/* Distrito */}
                <div>
                  <label htmlFor="distrito" className="block text-sm font-medium text-gray-700">
                    Distrito *
                  </label>
                  <input
                    type="text"
                    id="distrito"
                    name="distrito"
                    value={state.distrito}
                    onChange={handleChange}
                    className="mt-1 focus:ring-pink-custom focus:border-pink-custom block w-full shadow-sm sm:text-sm border-gray-300 rounded-md border p-2"
                    required
                  />
                </div>

                {/* Dirección */}
                <div className="md:col-span-3">
                  <label htmlFor="direccion" className="block text-sm font-medium text-gray-700">
                    Dirección Completa *
                  </label>
                  <input
                    type="text"
                    id="direccion"
                    name="direccion"
                    value={state.direccion}
                    onChange={handleChange}
                    className="mt-1 focus:ring-pink-custom focus:border-pink-custom block w-full shadow-sm sm:text-sm border-gray-300 rounded-md border p-2"
                    required
                  />
                </div>
              </div>
            </div>

            {/* Sección Detalle del Reclamo */}
            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-lg font-medium text-gray-900 mb-4">Detalle del Reclamo</h2>

              {/* Tipo de Reclamo */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Reclamo *</label>
                <div className="space-y-2">
                  <div className="flex items-center">
                    <input
                      id="queja"
                      name="tipoReclamo"
                      type="radio"
                      value="queja"
                      checked={state.tipoReclamo === "queja"}
                      onChange={handleChange}
                      className="focus:ring-pink-custom h-4 w-4 text-pink-custom  border-gray-300"
                      required
                    />
                    <label htmlFor="queja" className="ml-3 block text-sm font-medium text-gray-700">
                      Queja
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      id="reclamo"
                      name="tipoReclamo"
                      type="radio"
                      value="reclamo"
                      checked={state.tipoReclamo === "reclamo"}
                      onChange={handleChange}
                      className="focus:ring-pink-custom h-4 w-4 text-pink-custom  border-gray-300"
                    />
                    <label htmlFor="reclamo" className="ml-3 block text-sm font-medium text-gray-700">
                      Reclamo
                    </label>
                  </div>
                </div>
              </div>

              {/* Pedido relacionado */}
              <div className="mb-6">
                <label htmlFor="pedidoRelacionado" className="block text-sm font-medium text-gray-700">
                  Número de Pedido (opcional)
                </label>
                <input
                  type="text"
                  id="pedidoRelacionado"
                  name="pedidoRelacionado"
                  value={state.pedidoRelacionado}
                  onChange={handleChange}
                  className="mt-1 focus:ring-pink-custom focus:border-pink-custom block w-full shadow-sm sm:text-sm border-gray-300 rounded-md border p-2"
                />
              </div>

              {/* Detalle */}
              <div>
                <label htmlFor="detalleReclamo" className="block text-sm font-medium text-gray-700">
                  Detalle del Reclamo *
                </label>
                <textarea
                  id="detalleReclamo"
                  name="detalleReclamo"
                  rows={5}
                  value={state.detalleReclamo}
                  onChange={handleChange}
                  className="mt-1 focus:ring-pink-custom focus:border-pink-custom block w-full shadow-sm sm:text-sm border-gray-300 rounded-md border p-2"
                  placeholder="Describa con detalle su reclamo o queja..."
                  required
                />
              </div>

              {/* Archivo adjunto */}
              <div className="mt-6">
                <label className="block text-sm font-medium text-gray-700">Adjuntar Archivo (opcional)</label>
                <div className="mt-1 flex items-center">
                  <label
                    htmlFor="archivo"
                    className="cursor-pointer bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-custom">
                    Seleccionar archivo
                  </label>
                  <input id="archivo" name="archivo" type="file" onChange={handleChange} className="sr-only" />
                  {state.archivo && <span className="ml-4 text-sm text-gray-500">{state.archivo.name}</span>}
                </div>
                <p className="mt-2 text-sm text-gray-500">Puede adjuntar imágenes, facturas o documentos que respalden su reclamo (MAX 5MB)</p>
              </div>
            </div>

            {/* Botón de envío */}
            <div className="flex justify-end">
              <button
                type="submit"
                className="inline-flex justify-center py-3 px-6 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-rosado hover:bg-custom-rosado focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-custom">
                Enviar Reclamo
              </button>
            </div>
          </form>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default LibrodeReclamaciones;
